import { render, staticRenderFns } from "./ElementTiptap.vue?vue&type=template&id=75c1262f"
import script from "./ElementTiptap.vue?vue&type=script&lang=js"
export * from "./ElementTiptap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports